import React from 'react';
import { WebUrlData } from '@base-configs';
import { Navigate } from 'react-router-dom';

export function MaintenanceFeature() {
  return <Navigate to={WebUrlData.maintenance_log} replace />;
}
